

















































































































































import _ from 'lodash';
import { ShowFinally, Message, HumanizeTime } from 'mycorems-app-shared';
import { HasTaskMixin } from '@/mixins';
import { round } from '@/utils';
import {
  DetailedEmailCampaignMetric,
  QueryResult,
  QPagination,
  EmailCampaignFilters,
} from '@/types';
import eventBus from '@/messaging/event-bus';
import { EmailCampaignsFetched } from '@/messaging/events';
import Tooltip from '@/components/Tooltip.vue';
import repository from './email-campaign-repository';
import FetchStatus from './FetchStatus.vue';
import GenerateReportBtn from './report/GenerateReportBtn.vue';
import DownloadReportPdfBtn from './report/DownloadReportPdfBtn.vue';
import FetchEmailCampaignsBtn from './FetchEmailCampaignsBtn.vue';
import EmailCampaignPreviewBtn from './preview/EmailCampaignPreviewBtn.vue';

interface Data {
  emailCampaigns: DetailedEmailCampaignMetric[],
  pagination: QPagination,
  columns: object[],
  searchQuery: string|undefined,
  orderBy: string,
  order: string,
}

export default HasTaskMixin.extend({
  props: {
    accountId: {
      type: String,
      required: true,
    },
  },
  data(): Data {
    return {
      emailCampaigns: [],
      pagination: {
        page: 1,
        rowsPerPage: 10,
        rowsNumber: 0,
      },
      columns: [
        {
          name: 'campaign',
          align: 'left',
          label: 'Campaign Name',
          field: (ec: DetailedEmailCampaignMetric) => ec,
          orderBy: 'name',
        },
        {
          name: 'sentAt',
          align: 'left',
          label: 'Date Sent',
          field: (ec: DetailedEmailCampaignMetric) => ec.sentAt,
          orderBy: 'sent_at',
        },
        {
          name: 'recipients',
          align: 'center',
          label: 'Recipients',
          field: (ec: DetailedEmailCampaignMetric) => ec.summary.recipients,
          orderBy: 'recipients',
        },
        {
          name: 'uniqueOpens',
          align: 'center',
          label: 'Unique Opens',
          field: (ec: DetailedEmailCampaignMetric) => ec.summary.uniqueOpens,
          orderBy: 'unique_opens',
        },
        {
          name: 'openRate',
          align: 'center',
          label: 'Open %',
          title: 'Open Rate',
          orderBy: 'open_rate',
        },
        {
          name: 'clicks',
          align: 'center',
          label: 'Clicks',
          field: (ec: DetailedEmailCampaignMetric) => ec.summary.clicks,
          orderBy: 'clicks',
        },
        {
          name: 'ctr',
          label: 'CTR',
          title: 'Click Through Rate',
          align: 'center',
          orderBy: 'click_through_rate',
        },
        {
          name: 'bounceRate',
          label: 'Bounce %',
          title: 'Bounce Rate',
          align: 'center',
          orderBy: 'bounce_rate',
        },
        {
          name: 'unsubscribeRate',
          label: 'Unsub. %',
          title: 'Unsubscribe Rate',
          align: 'center',
          orderBy: 'unsubscribe_rate',
        },
        {
          name: 'spamRate',
          label: 'Spam %',
          title: 'Spam Rate',
          align: 'center',
          orderBy: 'spam_rate',
        },
        {
          name: 'status',
          align: 'center',
          label: 'Generate/View',
        },
      ],
      searchQuery: undefined,
      orderBy: 'sent_at',
      order: 'desc',
    };
  },
  watch: {
    accountId(): void {
      this.load();
    },
    filters: {
      handler(): void {
        this.load();
      },
      deep: true,
    },
    pagination: {
      handler(): void {
        this.load();
      },
      deep: true,
    },
  },
  computed: {
    filters(): EmailCampaignFilters {
      return {
        name: this.searchQuery,
        orderBy: this.orderBy,
        order: this.order,
        offset: (this.pagination.page - 1) * this.pagination.rowsPerPage,
        limit: this.pagination.rowsPerPage,
      };
    },
    oppositeOrderType(): 'asc'|'desc' {
      return (this.order === 'asc') ? 'desc' : 'asc';
    },
    orderIcon(): string {
      return (this.order === 'asc') ? 'fas fa-sort-amount-down-alt' : 'fas fa-sort-amount-up';
    },
    orderTitle(): string {
      return (this.order === 'asc') ? 'Ascending' : 'Descending';
    },
  },
  methods: {
    getOrderIcon(order: string): string {
      if (this.orderBy === order) {
        return this.orderIcon;
      }
      return 'fas fa-sort-amount-down-alt';
    },
    changeOrder(field: string) {
      if (!field) return;
      if (this.orderBy === field) {
        this.order = this.oppositeOrderType;
      }
      this.orderBy = field;
    },
    update(emailCampaign: DetailedEmailCampaignMetric): void {
      const index = this.emailCampaigns.findIndex(ec => ec.id === emailCampaign.id);
      if (index >= 0) {
        this.emailCampaigns.splice(index, 1, emailCampaign);
      }
    },
    load(): void {
      this.task = repository.findAll(this.accountId, this.filters);
      this.task.then((result: QueryResult) => {
        this.emailCampaigns = (result.items as DetailedEmailCampaignMetric[]);
        this.pagination.rowsNumber = result.total;
      });
    },
  },
  filters: {
    metric(value): string {
      if (_.isNaN(value) || _.isNil(value)) return '0';
      return round(value);
    },
  },
  created(): void {
    this.load();
    eventBus.$on(EmailCampaignsFetched.eventName, this.load);
  },
  beforeDestroy() {
    eventBus.$off(EmailCampaignsFetched.eventName, this.load);
  },
  components: {
    ShowFinally,
    Message,
    HumanizeTime,
    FetchStatus,
    GenerateReportBtn,
    DownloadReportPdfBtn,
    Tooltip,
    FetchEmailCampaignsBtn,
    EmailCampaignPreviewBtn,
  },
});
